import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ObtenerNumeroColeccionesService {
  private readonly coleccionesUrl: string;

  constructor(private httpClient: HttpClient) {
    this.coleccionesUrl = environment.apiUrl + '/administrador/colecciones/total';
  }

  public __invoke(): Observable<number> {
    return this.httpClient.get<number>(this.coleccionesUrl);
  }
}
